import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Modal from '@/popup/components/shared/Modal/Modal'
import Sanitize from '@/popup/components/shared/Sanitize.vue'
import Button from '@/popup/components/shared/Button.vue'
import { truncateMiddle } from '@/shared/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'DisconnectApp',
  props: {
    origin: { default: '' },
    onConfirm: { type: Function, default: () => Promise.resolve() },
    onCancel: { type: Function, default: () => ({}) }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal).Wrapper, null, {
    default: _withCtx(() => [
      _createVNode(_unref(Modal).Background, {
        "extra-class": "darker blurry",
        onClick: _ctx.onCancel
      }, null, 8 /* PROPS */, ["onClick"]),
      _createVNode(_unref(Modal).Content, null, {
        default: _withCtx(() => [
          _createVNode(_unref(Modal).Heading, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('modal.disconnect_app.heading')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_unref(Modal).Text, null, {
            default: _withCtx(() => [
              _createVNode(Sanitize, {
                html: 
            _ctx.$t('modal.disconnect_app.text', {
              origin: _unref(truncateMiddle)(encodeURI(_ctx.origin), 15),
            })
          
              }, null, 8 /* PROPS */, ["html"])
            ]),
            _: 1 /* STABLE */
          }),
          _createElementVNode("div", null, [
            _createVNode(Button, {
              variant: "primary",
              "is-full-width": true,
              "data-testid": "confirm",
              onClick: _ctx.onConfirm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('modal.disconnect_app.delete')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"]),
            _createVNode(Button, {
              class: "pb-0",
              variant: "text",
              "is-full-width": true,
              "data-testid": "cancel",
              onClick: _ctx.onCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('modal.disconnect_app.cancel')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})